module.exports = __webpack_public_path__ + "static/media/iconCvTheque.ed038d5a.svg";